export function getErrorStatus(error: any): number | undefined {
  return error?.response?.status ?? error?.status;
}

export async function getErrorMessage(
  error: any,
): Promise<string | undefined> {
  const responseData = error?.response?.data ?? error?.data;

  if (typeof responseData === 'string') {
    return responseData;
  }

  if (responseData instanceof Blob) {
    try {
      const blobText = await responseData.text();
      const trimmedText = blobText?.trim();

      if (trimmedText) {
        try {
          const parsed = JSON.parse(trimmedText);
          const parsedMessage = parsed?.message;

          if (Array.isArray(parsedMessage)) {
            return parsedMessage.join(', ');
          }

          if (typeof parsedMessage === 'string') {
            return parsedMessage;
          }
        } catch {
        }

        return trimmedText;
      }
    } catch {
    }
  }

  const messageFromResponse = responseData?.message;
  if (Array.isArray(messageFromResponse)) {
    return messageFromResponse.join(', ');
  }

  if (typeof messageFromResponse === 'string') {
    return messageFromResponse;
  }

  if (typeof error?.statusText === 'string' && error.statusText.trim()) {
    return error.statusText;
  }

  if (typeof error?.message === 'string') {
    return error.message;
  }

  return undefined;
}